import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/question/list'
    return request.post(url,data)
}

export function all() {
    let url = '/question/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/question/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/question/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/question/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/question/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/question/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/question/dmz/options'
    return request.get(url)
}
